import type { Locale } from '@/i18n/translations';

/** Every translated public response is isolated from donor credentials and other locales. */
export const publicKeys = {
  hierarchy: (locale: Locale) => ['public', 'hierarchy', locale] as const,
  organization: (reference: string, locale: Locale, unit?: string) =>
    ['public-organization', reference, locale, unit] as const,
  catalog: (id: string, locale: Locale, unit?: string) =>
    ['organization-projects', id, locale, unit] as const,
  fund: (id: string, kind: string, locale: Locale) =>
    ['organization-fund', id, kind, locale] as const,
  project: (slug: string | undefined, locale: Locale) => ['public-project', slug, locale] as const,
  gift: (organization: string | undefined, project: string | undefined, locale: Locale) =>
    ['giving-project', organization, project, locale] as const,
  giftRoute: (
    organization: string | undefined,
    project: string | undefined,
    reference: string | undefined,
    fund: string | undefined,
    locale: Locale,
  ) => ['giving-project', organization, project, reference, fund, locale] as const,
  picker: (id: string | undefined, locale: Locale) =>
    ['public', 'gift-picker-projects', id, locale] as const,
  churchFund: (id: string, kind: string, locale: Locale) =>
    ['public', 'home-fund', id, kind, locale] as const,
  recommended: (scope: string | undefined, locale: Locale) =>
    ['public', 'home-recommended', scope, locale] as const,
  homeProjects: (id: string, locale: Locale) => ['public', 'home-projects', id, locale] as const,
  privacy: (locale: Locale) => ['privacy-policy', locale] as const,
  payments: (locale: Locale) => ['payments-config', locale] as const,
  checkoutPolicy: (locale: Locale) => ['checkout-policy', locale] as const,
};
